import apiService from "./api-service";

class SurveyService {
	async getAllSurveys() {
		return await apiService.get("/verbal-area-model-management/", {
			area_id: localStorage.getItem("areaSelected"),
		});
	}

	async getSurveyById(id) {
		return await apiService.get(`/verbal-area-model-management`, {
			id: id,
			area_id: localStorage.getItem("areaSelected"),
		});
	}

	async createSurvey(surveyData) {
		return await apiService.post(
			"/verbal-area-model-management/",
			{},
			{
				json_data: surveyData,
				area_id: localStorage.getItem("areaSelected"),
			}
		);
	}

	async updateSurvey(id, surveyData) {
		return await apiService.put(`/verbal-area-model-management/${id}/`, {}, surveyData);
	}

	async deleteSurvey(id) {
		return await apiService.delete(`/verbal-area-model-management/`, {
			id: id,
			area_id: localStorage.getItem("areaSelected"),
		});
	}

	async saveSurveyResponse(surveyId, responseData) {
		return await apiService.post(
			"/verbal-area-model-response-management/",
			{},
			{
				id: surveyId,
				json_data: responseData,
				area_id: localStorage.getItem("areaSelected"),
			}
		);
	}

	async getSurveyResponses() {
		return await apiService.get(`/verbal-area-model-response-management/`, {
			area_id: localStorage.getItem("areaSelected"),
		});
	}

	async getSurveyResponseById(id) {
		return await apiService.get(`/verbal-area-model-response-management`, {
			id: id,
			area_id: localStorage.getItem("areaSelected"),
		});
	}

	async updateSurveyResponse(responseId, responseData) {
		return await apiService.put(
			`/verbal-area-model-response-management/`,
			{},
			{
				id: responseId,
				json_data: responseData,
				area_id: localStorage.getItem("areaSelected"),
			}
		);
	}
}

export default new SurveyService();
